import { Box } from '@mui/material';
import styled from 'styled-components';

import { getTheme } from '@commons/utils/theme';

const theme = getTheme();

// Container for header labels
export const HeaderLabelsContainer = styled(Box)`
  display: flex;
  height: 18px;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
`;

// Base component for header labels
export const HeaderLabel = styled(Box)`
  width: 60px;
  text-align: center;
  border-radius: 4px;
  padding: 1px 2px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BasicHeaderLabel = styled(HeaderLabel)`
  background-color: ${theme.colors.greys.lighter};
  border-radius: 4px;
`;

// Label for "To produce" in header
export const ToProduceHeaderLabel = styled(HeaderLabel)`
  background-color: ${theme.colors.brand.secondaryLight};
  border-radius: 4px;
`;

// Main container for timeslot header
export const TimeSlotHeaderContainer = styled(Box)`
  text-align: center;
`;

// Container for timeslot header with menu
export const TimeSlotHeaderWithMenuContainer = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

// Menu button for timeslot header
export const TimeSlotMenuButton = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  flex-shrink: 0;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.brand.primary : 'transparent'};

  &:hover {
    background-color: ${({ isActive, theme }) =>
      isActive ? theme.colors.brand.primary : theme.colors.greys.lighter};
  }
`;

export const TimeSlotMenuIcon = styled.img`
  width: 16px;
  height: 16px;
  filter: ${({ isActive }) => (isActive ? 'brightness(0) invert(1)' : 'none')};
`;

export const MenuItemIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;
